import { IData, IItemData } from './index'

export default function(api: GlobalFetch) {
  return async function(values) {
    const response = await api.fetch(`/api/v2/booking/add`, {
      method: 'POST',
      body: JSON.stringify(values),
    })

    return await handleResponse(response)
  }
}

const handleResponse = async (
  response: Response,
): Promise<Array<IItemData>> => {
  const { status } = response

  if (status === 200) {
    const data: IData = await response.json()
    return data.items
  }

  throw new Error('Error')
}
